import * as React from "react";
import { useEffect, useState } from "react";
import { analytics } from "../../analytics";
import { useOrganizationInvites } from "../../crud/invites/hooks";
import { useOrganization } from "../../crud/organizations/hooks";
import { Urls } from "../../domain/urls";
import { OrganizationMemberForm } from "./OrganizationMemberForm";
import { haveReachedMemberLimit, seatLimitAlertText } from "./util";
import { Page } from "../../components/layout/page";
import { UpgradeDialog } from "../../shared-components/UpgradeDialog";

export const AddOrganizationMemberForm = ({
  organizationId,
}: {
  organizationId: number;
}): React.ReactElement => {
  const { data: organization } = useOrganization(organizationId);
  const { data: orgInvites } = useOrganizationInvites(organization?.id);
  const [dialogOpen, setDialogOpen] = useState(false);

  const alertText = seatLimitAlertText(organization, orgInvites);

  const memberLimitReached = haveReachedMemberLimit(organization, orgInvites);

  useEffect(() => {
    if (organization && memberLimitReached) {
      analytics.track("add-member-blocked-by-limit");
      setDialogOpen(true);
    }
  }, [organization, memberLimitReached]);

  return (
    <Page
      title="Add Member"
      breadCrumbs={[
        {
          text: "Team",
          link: `/${Urls.Team}`,
        },
        {
          text: organization?.name || "",
        },
        {
          text: "Members",
        },
        { text: "Add" },
      ]}
    >
      <UpgradeDialog
        organizationId={organizationId}
        title="Member Limit Reached"
        alertText={alertText}
        open={dialogOpen && memberLimitReached}
        onClose={() => setDialogOpen(false)}
      />
      {organization && (
        <OrganizationMemberForm
          organizationId={organizationId}
          type="Membership"
          disable={memberLimitReached}
        />
      )}
    </Page>
  );
};
